import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {
    AuthorizationPasswordService,
    ResetUserPasswordRequest, StripeService,
    UpdateUserRequest,
    UserService
} from 'kfp';
import {AuthService} from '../auth/auth.service';


@Injectable({
    providedIn: 'root'
})
export class ProfileService {


    constructor(private _httpClient: HttpClient,
                private _userService: UserService,
                private _authService: AuthService,
                private _stripeService: StripeService,
                private _authPassService: AuthorizationPasswordService) {
    }

    public setNewPassword(
        req: ResetUserPasswordRequest
    ): Observable<any> {
        return this._authPassService.resetUserPassword(req);
    }

    updateAuthUser(id: string, user: UpdateUserRequest): any {
        return this._userService.updateUserById(id, user);
    }

    getAuthUser(): Observable<any> {
        return this._authService.profile();
    }



    get currency(): string {
        return 'Kč';
    }


    public getUpdateUserBranding(): any {
        return null;
    }

    public clearProfile(): void {
        this._authService.clearLoggedUserCache();
    }

    public activeProfile() {
        return this._authService.profile();
    }

    public refreshProfile() {
        return this._authService.refreshProfile();
    }

    public sendUpdateLogoToProject(message: any) {
        //this.userLogo.next(message);
    }

    putUserColor(id: string, color: string, colorSecondary: string): Observable<any> {
        // @ts-ignore
        return this._userService.updateUserColor(id, {color: color, colorSecondary: colorSecondary});
    }

    deleteLogo(id: string): Observable<any> {
        return this._userService.deleteLogoFromUser(id);
    }

    putUserLogo(id: string, file: Blob): any {
        return this._userService.updateUserLogo(id, file);
    }

    putUserAvatar(id: string, file: Blob): any {
        return this._userService.uploadAvatarToUser(id, file);
    }

    deleteAvatar(id: string): Observable<any> {
        return this._userService.deleteAvatarFromUser(id);
    }

    getAuthUserSubscription(): any {
        return this._stripeService.checkUserSubscription();
    }

    getStripeCoupon(coupon: string | undefined): any {
        return undefined;
    }

    getTrialUserInformation(): any {
        return null;
    }


}
